export default __webpack_public_path__ + "static/media/ariyibi_baseet_.9020ef2b.jpg";